export default __webpack_public_path__ + "static/media/lookup.9f2cc565.png";